@import '../utils/global.module.less';

.workstreamsRoot {
    width: 100%;
    height: 100%;
    position: relative;
}

.taskGroupTitle {
    align-self: center;
    color: #243a5c;
    font-size: 20px;
    font-family: LustTextItalic, serif !important;
    font-weight: 600;
    padding: 10px;
}

.taskGroup {
    border-top: 2px dashed #d0d5dd;
    min-width: 200px;
    flex: 1 0 200px;
}

.flexsContainer {
    gap: clamp(20px, calc(80px - var(--current-sidebar-width) * 0.3), 60px);
    padding: 10px;
    width: 100%;
    height: 100%;
    overflow: auto;
    flex-wrap: wrap;
}

.taskBox {
    margin-top: 8px;
    border: 1px #eceef2 solid;
    border-radius: 15px;
    background-color: #ffffff;
    .small-shadow();
}

.iconSize {
    width: 28px;
    height: 28px;
}

.taskIcon {
    background-color: #f9fafb;
    align-self: center;
    justify-self: center;
    padding: 7px;
    width: 42px;
    min-width: 42px;
    height: 42px;
    border-radius: 12px;
    transform: translate(5px, 0);
}

.taskPercentBg {
    background-color: #f9fafb;
    align-self: center;
    justify-self: center;
    width: 52px;
    min-width: 52px;
    height: 42px;
    border-radius: 12px;
    transform: translate(5px, 0);
}

.taskTitle {
    cursor: pointer;
    color: #243a5c;
    font-size: 15px;
    font-family: Hanken Grotesk;
    font-weight: 600;
}

.taskStatus {
    color: #475467;
    font-size: 13px;
    font-family: Hanken Grotesk;
    font-weight: 400;
}

.taskBoxContent {
    padding: 5px 12px 5px 12px;
    min-width: 0;
}

.taskViewContainer {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 500;
}

.clearButton {
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
    &:hover {
        transform: scale(1.2);
    }
}

